// @flow

import trackGtmEvent from '../trackGtmEvent';
import { listView } from '../../measurements';
import type { State } from '../../../types';

export const onCarImpression = (pdbId: ?string): Function => (
  async (dispatch: Function, getState: () => State) => {
    const state = getState();

    trackGtmEvent(
      listView(state, pdbId),
    );
  }
);
